import { render, staticRenderFns } from "./role_list_new.vue?vue&type=template&id=a37273d2&scoped=true&"
import script from "./role_list_new.vue?vue&type=script&lang=js&"
export * from "./role_list_new.vue?vue&type=script&lang=js&"
import style0 from "./role_list_new.vue?vue&type=style&index=0&id=a37273d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37273d2",
  null
  
)

export default component.exports